import { render, staticRenderFns } from "./modalCrearOC.vue?vue&type=template&id=9164b6c6&"
import script from "./modalCrearOC.vue?vue&type=script&lang=ts&"
export * from "./modalCrearOC.vue?vue&type=script&lang=ts&"
import style0 from "./modalCrearOC.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports